__turbopack_context__.v({
  "devScroll": "dev-module__otmXJW__devScroll",
});
